"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".host_3b86f12f{display:inline-block}.hostOverflow_3b86f12f{display:inline}\n" }]);
exports.host = "host_3b86f12f";
exports.hostOverflow = "hostOverflow_3b86f12f";
//# sourceMappingURL=TooltipHost.scss.js.map